<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/partnership">Partnership Opportunities</a></li>
                            <li><a routerLink="/officialpartners" class="active">Official Partners</a></li>
                            <li><a routerLink="/players-sponsor" >Entry Level Sponsorship</a></li>
                            <li><a routerLink="/commercial" >Captain’s Club </a></li>
                            <!-- <li><a routerLink="/boundary">The Boundary Club</a></li> -->
                            <!--<li><a routerLink="/advertising">LED Big Screen Advertising</a></li>-->
                            <!-- <li><a routerLink="/indiafixture">India Fixture</a></li> -->
                            <li><a routerLink="/hospitality">Match Day Hospitality</a></li>
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">

        </div>
    </div>
    <div class="commercial-bottom-section cf">
        <div class="container">
            <div class="commercial-bottom-partner" *ngFor="let sponsor of sponsorsList?.data">
                <div class="partner-title">
                    <h2 class="titel-name">{{sponsor?.title}}</h2>
                </div>
                <div class="partner-logo-detail">
                    <div class="partner-logo-box" *ngFor="let img of sponsor?.sponsors">
                        <div class="partner-logo-inner">
                            <a href="javascript:void(0)">
                                <img [src]="img?.image" [alt]="img?.title">
                            </a>
                        </div>
                    </div>
                    <!-- <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/img02.png">
                        </div>
                    </div>
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/dMU.png">
                        </div>
                    </div>
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/img05.png">
                        </div>
                    </div> -->
                </div>
            </div>
            <!-- <div class="commercial-bottom-partner">
                <div class="partner-title">
                    <h2 class="titel-name">ASSOCIATE SPONSORS</h2>
                </div>
                <div class="partner-logo-detail">
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/img05.png">
                        </div>
                    </div>
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/img02.png">
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="commercial-bottom-partner">
                <div class="partner-title">
                    <h2 class="titel-name">OFFICIAL PARTNERS</h2>
                </div>
                <div class="partner-logo-detail">
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/image(2).png">
                        </div>
                    </div>
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/image(3).png">
                        </div>
                    </div>
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/image(4).png">
                        </div>
                    </div>
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/image(1).png">
                        </div>
                    </div>
                </div>
            </div>
            <div class="commercial-bottom-partner">
                <div class="partner-title">
                    <h2 class="titel-name">MEDIA PARTNERS</h2>
                </div>
                <div class="partner-logo-detail">
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/img05.png">
                        </div>
                    </div>
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/img02.png">
                        </div>
                    </div>
                    <div class="partner-logo-box">
                        <div class="partner-logo-inner">
                            <img src="assets/images/dMU.png">
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</section><!-- page ends-->